// extracted by mini-css-extract-plugin
export default {"message":"FromCeo_message__tKEfe","quote":"FromCeo_quote__3VbxL","image":"FromCeo_image__Vwd8R","credentials":"FromCeo_credentials__4dUV1"};